module.exports = __webpack_public_path__ + "media/images/partner/pic_6-48ec381ed80ee66ce8a7037f7e3c6a08.png";